import React from 'react';
import { useAuth } from '../../context/AuthContext';
import ImageLabel from './ImageLabel';
import './UserCreditsView.css';
import { Link } from 'react-router-dom';

const UserCreditsView: React.FC = () => {
    const { user, balance } = useAuth();

    if (!user) return null;

    return (
        <div className="user-credits-view">
            <ImageLabel
                title='Amount of credits'
                imageSourceOrSvg="/img/coin.png"
                text={balance !== null ? balance.toString() : ''}
                textClassName='badge'
                isLoading={balance === null}
            />
            <Link to="/checkout" className="add">
                Buy +
            </Link>
        </div>
    );
};

export default UserCreditsView;

